import { AxiosError, isAxiosError } from 'axios';

interface IUpdateOfficeSetupApiResponseData {
  message?: string;
  error?: string;
  data?: { message?: string; error?: string };
}

const firstString = (...values: Array<string | undefined>): string | undefined =>
  values.find((v): v is string => typeof v === 'string' && v.trim().length > 0);

/**
 * Catch-all for axios errors that carry a BE-supplied message. Placed last in
 * the service chain so the user sees whatever copy the BE wrote instead of the
 * generic axios "Request failed with status code …" string.
 */
export class UpdateOfficeSetupApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UpdateOfficeSetupApiError';
  }

  static fromAxiosError(error: unknown): UpdateOfficeSetupApiError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IUpdateOfficeSetupApiResponseData>;
    const data = axiosError.response?.data;
    const message = firstString(
      data?.message,
      data?.error,
      data?.data?.message,
      data?.data?.error,
    );

    return message ? new UpdateOfficeSetupApiError(message) : null;
  }
}
